/* istanbul ignore file - to be imported from @vg-faset/utilities once custom Angular build work is done. */
/*
 * This is a custom tooltip for ChartJS that displays a gray
 * vertical line over the active index.
 */

export default {
  id: 'linePlugin',
  // eslint-disable-next-line complexity, max-statements
  /*eslint max-statements: ["error", 20]*/
  beforeDatasetsDraw: function (chart) {
    if (chart.tooltip._active && chart.tooltip._active.length) {
      const activePoint = chart.tooltip._active[0]
      const ctx = chart.ctx
      const y_axis = chart.scales['y-axis-0']
      const x = activePoint.tooltipPosition().x
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      const topY = 0
      let bottomY = y_axis.bottom

      // Extend line over x axis for synced charts
      if (ctx.canvas.parentNode.classList.contains('line-chart--synced')) {
        bottomY = ctx.canvas.height
      }
      // draw line
      ctx.save()
      ctx.beginPath()
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      ctx.moveTo(x, topY)
      ctx.lineTo(x, bottomY)
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      ctx.lineWidth = 2
      ctx.strokeStyle = '#eaeaea'
      ctx.stroke()
      ctx.restore()
    }
  },
}
